(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (!root.KPTDelivery) { root.KPTDelivery = api; api.start(document); }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var DAY = 86400000;
  var defaults = {
    workingWeekdays: [1, 2, 3, 4, 5, 6], holidays: [], processing: [1, 2],
    regions: { nashik: [2, 3], maharashtra: [4, 5], india: [5, 7], remote: [7, 10] }
  };
  function iso(day) { return new Date(day * DAY).toISOString().slice(0, 10); }
  function parseDay(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) throw Error('date');
    var day = Date.parse(value + 'T00:00:00Z') / DAY;
    if (!Number.isInteger(day) || iso(day) !== value) throw Error('date');
    return day;
  }
  function indiaDay(now) {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    var values = {};
    parts.forEach(function (p) { values[p.type] = p.value; });
    return parseDay(values.year + '-' + values.month + '-' + values.day);
  }
  function validPin(value) { return typeof value === 'string' && /^[1-9]\d{5}$/.test(value); }
  function range(value) {
    if (!Array.isArray(value) || value.length !== 2 || !value.every(function (n) { return Number.isInteger(n) && n > 0 && n <= 60; }) || value[0] > value[1]) throw Error('range');
    return value.slice();
  }
  function policy(value) {
    var p = typeof value === 'string' ? JSON.parse(value || '{}') : value || {};
    var result = {
      workingWeekdays: p.workingWeekdays || defaults.workingWeekdays,
      holidays: p.holidays || [], processing: range(p.processing || defaults.processing), regions: {}
    };
    if (!Array.isArray(result.workingWeekdays) || !result.workingWeekdays.length || !result.workingWeekdays.every(function (d) { return Number.isInteger(d) && d >= 0 && d <= 6; })) throw Error('weekdays');
    if (!Array.isArray(result.holidays)) throw Error('holidays');
    result.holidays = result.holidays.map(parseDay);
    Object.keys(defaults.regions).forEach(function (key) {
      result.regions[key] = range(p.regions && p.regions[key] || defaults.regions[key]);
      if (result.regions[key][0] < result.processing[0] || result.regions[key][1] < result.processing[1]) throw Error('processing');
    });
    return result;
  }
  function addWorkingDays(day, count, p) {
    var remaining = count;
    for (var limit = 0; remaining && limit < 3700; limit++) {
      day++;
      if (p.workingWeekdays.indexOf(new Date(day * DAY).getUTCDay()) >= 0 && p.holidays.indexOf(day) < 0) remaining--;
    }
    if (remaining) throw Error('calendar');
    return day;
  }
  function windowFrom(day, days, p) { return { from: iso(addWorkingDays(day, days[0], p)), to: iso(addWorkingDays(day, days[1], p)) }; }
  function timeline(now, p, region) {
    var day = indiaDay(now);
    return { orderDate: iso(day), dispatch: windowFrom(day, p.processing, p), arrival: region ? windowFrom(day, p.regions[region], p) : null };
  }
  function postalRecord(records, pin) {
    var item = Object.prototype.hasOwnProperty.call(records, pin) ? records[pin] : null;
    if (!item || item.postalVerified !== true || typeof item.source !== 'string' || !/^https:\/\//.test(item.source) || !Object.prototype.hasOwnProperty.call(defaults.regions, item.region)) return null;
    if (typeof item.city !== 'string' || typeof item.state !== 'string') return null;
    return item;
  }
  function localEstimate(pin, records, now, p) {
    if (!validPin(pin)) return { status: 'invalid' };
    var item = postalRecord(records, pin);
    if (!item) return { status: 'unknown' };
    if (item.deliveryDisabled === true) return { status: 'unavailable' };
    return { status: 'indicative', place: item.city + ', ' + item.state, timeline: timeline(now, p, item.region), cod: null };
  }
  function proxyPath(path) {
    if (!/^\/apps\/[a-zA-Z0-9/_-]+$/.test(path)) throw Error('proxy');
    return path;
  }
  function verifiedResult(data, pin, now, times) {
    var age = now.getTime() - Date.parse(data && data.checkedAt);
    if (!data || data.verified !== true || data.originPincode !== '422004' || data.pincode !== pin || data.orderDate !== times.orderDate || typeof data.serviceable !== 'boolean' || !Number.isFinite(age) || age < -60000 || age > 900000) throw Error('verification');
    if (!data.serviceable) return { status: 'unavailable' };
    var arrival = data.arrival;
    if (!arrival || parseDay(arrival.from) < parseDay(times.dispatch.from) || parseDay(arrival.to) < parseDay(times.dispatch.to) || parseDay(arrival.from) > parseDay(arrival.to)) throw Error('arrival');
    return { status: 'verified', place: typeof data.place === 'string' ? data.place : pin, timeline: { orderDate: times.orderDate, dispatch: times.dispatch, arrival: arrival }, cod: typeof data.codAvailable === 'boolean' ? data.codAvailable : null };
  }
  function formatDate(value, locale) {
    return new Intl.DateTimeFormat(locale || 'en-IN', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' }).format(new Date(parseDay(value) * DAY));
  }
  function formatRange(value, locale) { return formatDate(value.from, locale) + (value.from === value.to ? '' : ' – ' + formatDate(value.to, locale)); }
  var maps = {};
  function loadMap(url, fetcher) {
    if (!maps[url]) {
      var control = new AbortController();
      var timeout = setTimeout(function () { control.abort(); }, 10000);
      maps[url] = fetcher(url, { credentials: 'same-origin', signal: control.signal }).then(function (r) {
      if (!r.ok) throw Error('map');
      return r.json();
    }).then(function (data) {
      if (!data || !data.pincodes || typeof data.pincodes !== 'object' || Array.isArray(data.pincodes)) throw Error('map');
      return data.pincodes;
      }).catch(function (error) { delete maps[url]; throw error; }).finally(function () { clearTimeout(timeout); });
    }
    return maps[url];
  }
  function mount(el, environment) {
    if (el.__kptDelivery) return el.__kptDelivery;
    var env = environment || {}, doc = el.ownerDocument;
    var now = env.now || function () { return new Date(); };
    var fetcher = env.fetch || function (url, options) { return window.fetch(url, options); };
    var config = JSON.parse(el.querySelector('[data-kpt-config]').textContent);
    var labels = config.labels, p, configError = false, overrides = {};
    try {
      p = policy(config.policy);
      overrides = JSON.parse(config.overrides || '{}');
      if (!overrides || typeof overrides !== 'object' || Array.isArray(overrides)) throw Error('overrides');
      if (config.proxy) proxyPath(config.proxy);
    } catch (error) { configError = true; }
    var input = el.querySelector('[data-kpt-pin]'), button = el.querySelector('[data-kpt-check]');
    var message = el.querySelector('[data-kpt-status]'), eta = el.querySelector('[data-kpt-eta]');
    var order = el.querySelector('[data-kpt-order]'), dispatch = el.querySelector('[data-kpt-dispatch]'), arrival = el.querySelector('[data-kpt-arrival]');
    var cod = el.querySelector('[data-kpt-cod]');
    var controller, serial = 0, lastPin = '', date = iso(indiaDay(now())), disposed = false;
    function blank(text, state) {
      message.textContent = text;
      el.dataset.state = state || 'idle';
      eta.textContent = '—'; dispatch.textContent = '—'; arrival.textContent = '—';
      order.textContent = formatDate(iso(indiaDay(now())), config.locale);
      cod.textContent = labels.cod_unknown;
    }
    function cancel() { serial++; if (controller) controller.abort(); el.removeAttribute('aria-busy'); button.textContent = labels.check; }
    function show(result) {
      input.setAttribute('aria-invalid', String(result.status === 'invalid'));
      if (result.status !== 'indicative' && result.status !== 'verified') {
        blank(labels[result.status] || labels.error, result.status);
        if (result.status === 'unavailable') cod.textContent = labels.cod_unavailable;
        return;
      }
      el.dataset.state = result.status;
      message.textContent = result.place + ' · ' + labels[result.status];
      eta.textContent = formatRange(result.timeline.arrival, config.locale);
      order.textContent = formatDate(result.timeline.orderDate, config.locale);
      dispatch.textContent = formatRange(result.timeline.dispatch, config.locale);
      arrival.textContent = formatRange(result.timeline.arrival, config.locale);
      cod.textContent = result.cod === true ? labels.cod_available : result.cod === false ? labels.cod_unavailable : labels.cod_unknown;
    }
    function context() {
      var product = el.closest('[data-km-product]');
      var variant = product && product.querySelector('[data-km-variant]');
      var quantity = product && product.querySelector('[name="quantity"]');
      return { variantId: variant ? variant.value : config.variantId, quantity: quantity ? Math.max(1, Number(quantity.value) || 1) : 1 };
    }
    async function check() {
      cancel();
      var pin = input.value.trim(), request = serial, stamp = now();
      lastPin = '';
      if (!validPin(pin)) { show({ status: 'invalid' }); return; }
      if (configError) { blank(labels.configuration, 'error'); return; }
      lastPin = pin;
      blank(labels.checking, 'loading'); el.setAttribute('aria-busy', 'true');
      var requestController = new AbortController();
      controller = requestController;
      var timeout = setTimeout(function () { requestController.abort(); }, 10000);
      try {
        var result;
        if (config.proxy) {
          var times = timeline(stamp, p), selection = context();
          var response = await fetcher(config.proxy, {
            method: 'POST', credentials: 'same-origin', signal: controller.signal,
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ originPincode: '422004', pincode: pin, productId: config.productId, variantId: selection.variantId, quantity: selection.quantity, orderDate: times.orderDate, dispatch: times.dispatch })
          });
          if (!response.ok) throw Error('courier');
          result = verifiedResult(await response.json(), pin, now(), times);
        } else {
          var base = await loadMap(config.mapUrl, fetcher);
          var records = Object.assign({}, base, overrides);
          result = localEstimate(pin, records, stamp, p);
        }
        if (disposed || request !== serial) return;
        if (iso(indiaDay(now())) !== iso(indiaDay(stamp))) { check(); return; }
        show(result);
        if (result.status === 'indicative' || result.status === 'verified') {
          try { window.localStorage.setItem('km-pin', pin); } catch (error) {}
        }
      } catch (error) { if (!disposed && request === serial) blank(labels.error, 'error'); }
      finally {
        clearTimeout(timeout);
        if (request === serial) { el.removeAttribute('aria-busy'); button.textContent = labels.check; }
      }
    }
    function changed() { cancel(); lastPin = ''; input.removeAttribute('aria-invalid'); blank(labels.prompt); }
    function keydown(event) { if (event.key === 'Enter') { event.preventDefault(); check(); } }
    function refresh() {
      var next = iso(indiaDay(now()));
      if (next !== date) { date = next; if (lastPin) check(); else blank(labels.prompt); }
    }
    function selectionChanged() {
      if (config.proxy && lastPin) { cancel(); lastPin = ''; blank(labels.prompt); }
    }
    function quantityInput(event) {
      if (event.target.matches('[data-km-qty], [data-km-sticky-qty]')) selectionChanged();
    }
    function quantityClick(event) {
      if (event.target.closest('[data-km-q]')) selectionChanged();
    }
    var productRoot = el.closest('[data-km-product]');
    input.addEventListener('input', changed); input.addEventListener('keydown', keydown); button.addEventListener('click', check);
    if (productRoot) { productRoot.addEventListener('change', selectionChanged); productRoot.addEventListener('kpt:variant-change', selectionChanged); productRoot.addEventListener('input', quantityInput); productRoot.addEventListener('click', quantityClick); }
    doc.addEventListener('visibilitychange', refresh);
    var timer = setInterval(refresh, 60000);
    blank(configError ? labels.configuration : labels.prompt, configError ? 'error' : 'idle');
    try { var saved = window.localStorage.getItem('km-pin'); if (validPin(saved)) { input.value = saved; check(); } } catch (error) {}
    var api = { check: check, destroy: function () {
      disposed = true; cancel(); clearInterval(timer);
      input.removeEventListener('input', changed); input.removeEventListener('keydown', keydown); button.removeEventListener('click', check); doc.removeEventListener('visibilitychange', refresh);
      if (productRoot) { productRoot.removeEventListener('change', selectionChanged); productRoot.removeEventListener('kpt:variant-change', selectionChanged); productRoot.removeEventListener('input', quantityInput); productRoot.removeEventListener('click', quantityClick); }
      delete el.__kptDelivery;
    } };
    el.__kptDelivery = api;
    return api;
  }
  function start(doc) {
    function init(scope) { scope.querySelectorAll('[data-kpt-delivery]').forEach(function (el) { mount(el); }); }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); }, { once: true });
    else init(doc);
    doc.addEventListener('shopify:section:load', function (event) { init(event.target); });
    doc.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('[data-kpt-delivery]').forEach(function (el) { if (el.__kptDelivery) el.__kptDelivery.destroy(); }); });
  }
  return { defaults: defaults, policy: policy, parseDay: parseDay, indiaDay: indiaDay, iso: iso, validPin: validPin, addWorkingDays: addWorkingDays, timeline: timeline, localEstimate: localEstimate, verifiedResult: verifiedResult, proxyPath: proxyPath, mount: mount, start: start };
});
